import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PwMyRequestsComponent } from './pw-my-requests.component';

const routes: Routes = [
  {
    path: '',
    component: PwMyRequestsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PwMyRequestsRoutingModule {}
